import React from 'react';

import { Container } from 'reactstrap';

const UnauthenticatedHeader = () => {
    return (
        <Container
            className="header d-lg-flex"
            role="complementary"
            aria-label="Most top header"
        >
            <div className="d-flex flex-grow-0 align-items-center">
                <img src={require('./ahc_logo.png')} height={80} alt="Logo"
                     style={{ marginTop: 20, marginLeft: 20}} />
            </div>
        </Container>
    );
};

export { UnauthenticatedHeader };
